<div class="pricing-display">
  <span>{{ pricing.currency }}</span>
  <span>{{ pricing.price }}</span>
  <span class="text-lighter">{{ pricing.unit }}</span>
</div>
